import { styled } from 'parkdepot-shared/theme'

export const Container = styled<'div', { $height?: string }>('div', ({ $theme, $height }) => ({
    position: 'sticky',
    bottom: '72px', // TODO: Improve this hardcode
    width: '100vw',
    height: $height ? $height : '10rem',
    // zIndex: 1,

    [$theme.mediaQuery.large]: {
        width: '47.8rem',
        margin: '0 auto',
        bottom: 0
    }
}))
